import { CButton, CCol, CForm, CFormInput, CFormLabel, CFormSelect, CRow } from '@coreui/react';
import React, { useEffect, useState } from 'react';
import AxiosInstance from '../Axios';
import MyToastify from '../myComponents/MyToactify';

// Компонент для зміни ТТН
const PreOrdersTTN = (props) => {
    // console.log('PreOrdersTTN props', props);

    const urlApi = '/pre_orders';
    const [ttn, setTtn] = useState("");
    const [isDisabledStatusBtn, setIsDisavledStatusBtn] = useState(false); // чи заблоковувати кнопку для збереження змін

    // Викликає popup з власного компонента
    const popup = MyToastify();

    // Відслідковувати чи заблоковувати кнопку для збереження змін
    useEffect(() => {
        if (props.MyData?.ttn === ttn) {
            setIsDisavledStatusBtn(true);
        } else if (props.MyData?.ttn !== "" && ttn === "") {
            setIsDisavledStatusBtn(false);
        } else {
            setIsDisavledStatusBtn(false);
        };
    }, [props.MyData?.ttn, ttn]);

    useEffect(() => {
        if (props.MyData?.ttn) {
            setTtn(props.MyData.ttn);
        };
    }, []);

    // Дані для оновлення замовлення
    const data_response = {
        "ttn": ttn,
    };

    // Запит на оформлення замовлення
    const updatePreOrder = async () => {
        try {
            const response = await AxiosInstance.put(`${urlApi}/${props.MyData.id}`, data_response);
            // console.log("response", response);
            setIsDisavledStatusBtn(true);
            // Оовити дані замовлення
            props.setMyData(response.data);
            // Popup про успішні зміни
            popup.toastifySuccess(props.popupTextSuccess);
        } catch (error) {
            setIsDisavledStatusBtn(false);
            console.error("Помилка запиту на оновлення замовлення: ", error);
            // Показати повідомлення про помилку
            popup.toastifyWarning(props.popupTextError);
        };
    };

    // Надіслати форму
    const handleSubmit = event => {
        event.preventDefault();
        setIsDisavledStatusBtn(true);
        updatePreOrder();
    };

    return (
        <CForm onSubmit={handleSubmit}>
            <CRow>
                <CCol md={6}>
                    <div className="mb-3">
                        {/* <CFormLabel htmlFor="exampleFormControlInput1">ТТН</CFormLabel> */}
                        <CFormInput type="text" id="exampleFormControlInput3" value={ttn} onChange={(e) => setTtn(e.target.value)} autoComplete="off" />
                    </div>
                </CCol>
                <CCol md={6} style={{ textAlign: "end" }}>
                    <CButton type="submit" color="success" disabled={isDisabledStatusBtn}>Зберегти</CButton>
                </CCol>
            </CRow >
        </CForm >
    );
};

export default PreOrdersTTN;